import {utilHelper} from "../../_helpers";

const relativeUrl = 'api/activityMedia'

export const activityMediaService = {
    search,
    getItem,
    saveItem,
    deleteItem,
    migrateData,
};

function search(data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search`, 'POST', { data:data, showAlert:false })
}

function getItem(id) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'GET',{ showAlert:false })
}

function saveItem(data) {
    return utilHelper.doRequestFileHandleResponse(`${relativeUrl}`, 'POST', data);
}

function deleteItem(id) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'DELETE',{})
}

function migrateData(json) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/migrate`, 'POST',{data:json})
}
